/**
 * Ordenacao e cores por nome de env. Migrado de tenantGrouping.ts (deprecated).
 *
 * Usado pelo builder pra ordenar Sub-UOs kind=environment e por OuBranchNode
 * pra colorir o badge.
 */

export const ENV_ORDER: Record<string, number> = {
  prd: 0,
  stg: 1,
  hml: 2,
  qa: 3,
  dev: 4,
  sandbox: 5,
}

export const ENV_COLORS: Record<string, string> = {
  prd: 'red',
  hml: 'yellow',
  dev: 'blue',
  stg: 'orange',
  qa: 'grape',
  sandbox: 'gray',
}

/**
 * Resolve a posicao de ordenacao do env. Custom envs vao para o final
 * preservando ordem alfabetica entre si (100 + charCode da primeira letra).
 */
export function orderForEnv(env: string | null | undefined): number {
  if (!env) return 999
  return ENV_ORDER[env.toLowerCase()] ?? 100 + env.toLowerCase().charCodeAt(0)
}

/**
 * Resolve a cor do env com fallback 'gray' para envs custom (VPN, SBOX,
 * SaaS, PERF, etc.) ainda sem cor canonica.
 */
export function colorForEnv(env: string | null | undefined): string {
  if (!env) return 'gray'
  return ENV_COLORS[env.toLowerCase()] ?? 'gray'
}
